import styled, { css } from 'styled-components'

import config from '../config'

import plusImg from '../images/plus.svg'
import checkImg from '../images/check.svg'
import checkImgWhite from '../images/check_white.svg'
import checkImgLightblue from '../images/check_lightblue.svg'
import checkPaybackImg from '../images/check_payback.svg'
import checkPaybackWhiteImg from '../images/check_payback_white.svg'

const List = styled.ul`
  margin: 0 0 1.25rem 0;
  padding: 0;
  list-style: none;

  ${props =>
    props.color === 'white' &&
    css`
      color: #fff;

      ${Item}::before {
        background-image: url(${checkImgWhite});
      }
    `}

  ${props =>
    props.color === 'payback' &&
    css`
      ${Item}::before {
        background-image: url(${checkPaybackImg});
      }

      ${props =>
        props.white &&
        css`
          ${Item}::before {
            background-image: url(${checkPaybackWhiteImg});
          }
        `}
    `}

  ${props =>
    props.color === 'blue' &&
    css`
      ${Item}::before {
        background-image: url(${checkImgLightblue});
      }
    `}

  ${props =>
    props.small &&
    css`
      ${Item} {
        padding-left: 25px;
      }
      ${Item}::before {
        background-size: 20px 15px;
        width: 20px;
        height: 15px;
        top: 2px;
      }
    `}

  ${props =>
    props.inline &&
    css`
      margin: 0;

      ${Item} {
        display: inline-block;
        margin: 0 10px;
      }
    `}

  ${props =>
    props.bold &&
    css`
      font-family: 'BentonSans';
      font-weight: bold;

      ${props =>
        props.theme.name === 'payback' &&
        css`
          font-family: 'PAYBACK_Bold';
          font-stretch: normal;
        `}
    `}
  ${props =>
    props.bold900 &&
    css`
      ${config.css.fontBentonBlack};
    `}
`

const Item = styled.li`
  display: block;
  position: relative;
  padding-left: 32px;
  line-height: 1.3;
  margin-bottom: 15px;

  ${props =>
    props.theme.name === 'payback' &&
    css`
      padding-left: 40px;
    `}

  &:last-child {
    margin-bottom: 0;
  }

  &::before {
    content: '';
    display: block;
    background: url(${checkImg}) center center no-repeat;
    background-size: 23px 18px;
    width: 23px;
    height: 18px;
    position: absolute;
    top: 0.2em;
    left: 0;

    ${props =>
      props.icon === 'plus' &&
      css`
        background-image: url(${plusImg}) !important;
        background-size: 18px 18px;
        width: 18px;
        height: 18px;
      `}

    ${props =>
      props.theme.name === 'platinum' &&
      css`
        background-image: url(${checkImgLightblue});
      `}
  }

  > span {
    font-family: 'BentonSans Book';
    font-weight: normal;

    ${props =>
      props.theme.name === 'payback' &&
      css`
        font-family: 'PAYBACK_Light';
        font-weight: 300;
      `}
  }

  ul {
    list-style: disc;
    padding-left: 20px;
  }
`

const Info = styled.div`
  font-family: 'BentonSans Book';
  font-weight: normal;
  padding-top: 10px;

  ${props =>
    props.theme.name === 'payback' &&
    css`
      font-family: 'PAYBACK_Light';
      font-weight: 300;
    `}
`

List.Item = Item
List.Info = Info

export default List
